import styled from "styled-components";

export const JoinDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 24px;
  gap: 24px;
  padding: 16px;
`;